import { createRouter, createWebHistory } from "vue-router";
import store from '../src/store/index.js';

//import website
import indexPage from "../src/views/index.vue";
import reservationPage from "../src/views/reservation.vue";
import searchPage from "../src/views/search.vue";
import loginPage from "../src/views/login.vue";
import whatsappPage from "../src/views/whatsapp.vue";
import updateDataPage from "../src/views/update_data.vue";
import updatePasswordPage from "../src/views/update_password.vue";
import contentsPage from "../src/views/contents.vue";
import examsPage from "../src/views/exams/index.vue";
import examDetailsPage from "../src/views/exams/show.vue";
import myExamsPage from "../src/views/my_exams/index.vue";
import myExamsDetailPage from "../src/views/my_exams/show.vue";
// import forgetPage from "../src/views/forget.vue";

// import NotFound from "../src/views/error.vue";


const routes = [
    // Website routes
    { path: "/", component: indexPage, name: "index" },
    { path: "/reservation", component: reservationPage, name: "reservation" },
    { path: "/search", component: searchPage, name: "search" },
    { path: "/whatsapp_link", component: whatsappPage, name: "whatsapp_link", meta: { requiresAuth: true } },
    { path: "/contents", component: contentsPage, name: "contentsPage", meta: { requiresAuth: true } },
    { path: "/update_password", component: updatePasswordPage, name: "update_password", meta: { requiresAuth: true } },
    { path: "/update_data", component: updateDataPage, name: "update_data", meta: { requiresAuth: true } },
    { path: "/exams", component: examsPage, name: "exams", meta: { requiresAuth: true } },
    { path: "/exam/:id", component: examDetailsPage, name: "examDetailsPage", meta: { requiresAuth: true } },
    { path: "/my_exams", component: myExamsPage, name: "myExamsPage", meta: { requiresAuth: true } },
    { path: "/my_exam/:id", component: myExamsDetailPage, name: "myExamsDetailPage", meta: { requiresAuth: true } },
    { path: "/login", component: loginPage, name: "login", meta: { guest: true } },
    // { path: "/forget", component: forgetPage, name: "forget" },
    // { path: "/404", component: NotFound},
    // { path: "/:catchAll(.*)", redirect: "/404"},
];

const router = createRouter({
    routes,
    history: createWebHistory(),
    hashbang: false,
    mode: 'html5',
    linkActiveClass: "active",
    // linkExactActiveClass: "exact-active",
    scrollBehavior() {
        // Scroll to the top of the page
        return window.scrollTo({ top: 0, behavior: 'smooth' });
    },
});

// جلب حالة الموقع من localStorage أو من متغير جلوبال
router.beforeEach((to, from, next) => {
    const website_status = Number(localStorage.getItem('website_status')) || 0;

    // إذا الصفحة تتطلب تسجيل دخول
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
        } else {
            next('/login');
        }
        return;
    }

    // إذا الصفحة للزوار فقط
    if (to.matched.some(record => record.meta.guest)) {
        if (store.getters.isAuthenticated) {
            next('/');
        } else {
            next();
        }
        return;
    }

    else if (website_status === 0) {
        if (to.path === '/' || to.path === '/search' || to.path === '/login' || to.path === '/whatsapp_link') {
            next();
        } else {
            next('/'); // إعادة توجيه لأي صفحة أخرى
        }
        return;
    }

    // السماح بالانتقال لأي صفحة أخرى
    next();
});

export default router;